module.exports = __webpack_public_path__ + "static/media/long_collar.3abc16e3.svg";